export enum CommissionActionType {
	BUY_SERVICE = 1,
	SELL_SERVICE = 2,
	EXCHANG_ESERVICE = 3,
	CHARGE_WALLET_BANK = 4,
	CHARGE_WALLET_CASH = 5,
	WALLET_WITHDRAWAL_BANK = 6,
	WALLET_WITHDRAWAL_CASH = 7,
	BETWEEN_MY_WALLETS = 8,
	INTERNAL_TRANSFER = 9,
	WITHDRAWAL_POINT = 10,
	VOUCHER_SERVICE = 11,
	SMS_PANEL_CHARGE = 12,
	CHARGE_WALLET_CREDIT = 13
}
